import {
  FadeInNoDelayAnimationFast,
  FlexCenter,
  Transition,
} from '@oneToOne/shared/twind'
import { css } from 'twind/css'

export const customerSurveyWrapper = css({
  ...FadeInNoDelayAnimationFast,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  background: 'var(--white)',
  padding: 'var(--spacing-24)',
  borderRadius: 'var(--spacing-8)',
  textAlign: 'center',
  overflowY: 'auto',
})

export const okButton = css({
  ...Transition,
  flexShrink: 0,
  width: '100%',
  height: '32px',
  marginBottom: 'var(--spacing-16)',
  borderRadius: 'var(--spacing-4)',
  background: 'var(--primary)',
  fontWeight: 'var(--font-normal)',
  fontSize: 'var(--font-size-sm)',
  cursor: 'pointer',
  pointerEvents: 'auto !important',

  '&:disabled': {
    cursor: 'not-allowed',
    background: 'var(--blue-2)',
    filter: 'unset',
  },
})

export const closeButton = css`
  border-radius: var(--border-radius-base);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: #bdbdbd;
  color: var(--off-black);
  padding: 7px 21px;
  margin-top: var(--spacing-12);
  font-weight: var(--font-semibold);
  font-size: var(--font-size-base);
  position: absolute;
  bottom: 40px;
  left: var(--spacing-24);
  right: var(--spacing-24);
  &:hover {
    border-width: 2px;
    bottom: 39px;
  }
  &:active {
    border-color: var(--gray3);
    border-width: 2px;
    bottom: 39px;
  }
`

export const customerSurveyContent = css`
  margin-top: 56px;

  @media screen and (max-height: 500px) {
    margin-top: 28px;
  }

  @media screen and (max-height: 320px) {
    margin-top: 10px;
  }
`

export const agentImageContainer = css({
  ...FlexCenter,
  flexDirection: 'column',
  marginBottom: 'var(--spacing-8)',
  width: '100%',
  height: '100%',
})

export const agentImage = css`
  width: 52px;
  height: 52px;
  object-fit: cover;
  object-position: top;
  border-radius: 50%;
`

export const headerText = css`
  color: var(--blk1);
  font-weight: var(--font-semibold);
  margin-bottom: var(--spacing-24);
`

export const questionText = css`
  color: 'var(--gray-9)';
`

export const questionSubText = css`
  color: var(--gray-7);
  margin-bottom: var(--spacing-8);
`

export const questionTextArea = css`
  border: 1px solid var(--gray-5);
  border-radius: var(--spacing-4);
  width: 100%;
  resize: vertical;
  min-height: 96px;
  max-height: 350px;
  padding: var(--spacing-8);
  font-size: var(--font-size-sm);
  font-family: inherit;
`

export const successWrapper = css({
  ...FlexCenter,
  ...Transition,
  ...FadeInNoDelayAnimationFast,
  height: '100%',
  width: '100%',
  justifyContent: 'space-between',
  flexDirection: 'column',
})

export const feedbackText = css`
  margin-top: var(--spacing-12);
  color: var(--blk1);
  font-weight: var(--font-semibold);
`
